import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  MessageCircle,
  Calendar,
  ArrowRight,
  HeadphonesIcon,
  Send
} from 'lucide-react';
import { SendMessagetoAdmin } from '../../../api/helper';
import { ShowToast } from '../../../helpers/ToastService';
import { useNavigate } from 'react-router-dom';

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    userType: '',
    subject: '',
    message: ''
  });
const navigate = useNavigate();


  const contactMethods = [
    {
      icon: Phone,
      title: "Call Us",
      description: "Speak directly with our team",
      action: "(555) 123-4567",
      subtext: "Available 24/7 for emergencies",
      color: "blue",
      gradient: "blue-500"
    },
    {
      icon: MessageCircle,
      title: "Live Chat",
      description: "Get instant support online",
      action: "Start Chat",
      subtext: "Response time under 5 minutes",
      color: "green",
      gradient: "green-500"
    },
    {
      icon: Mail,
      title: "Email Support",
      description: "Send us your questions",
      action: "support@mindcare.com",
      subtext: "We respond within 2 hours",
      color: "purple",
      gradient: "purple-500"
    },
    {
      icon: Calendar,
      title: "Schedule Consultation",
      description: "Book a time that works for you",
      action: "Book Now",
      subtext: "Same-day appointments available",
      color: "purple",
      gradient: "amber-500"
    }
  ];

  const officeInfo = [
    {
      icon: MapPin,
      title: "Main Office",
      details: ["123 Healthcare Blvd", "Suite 400", "Medical City, MC 12345"],
      color: "blue"
    },
    {
      icon: Clock,
      title: "Business Hours",
      details: ["Monday - Friday: 8:00 AM - 8:00 PM", "Saturday: 9:00 AM - 5:00 PM", "Sunday: Emergency only"],
      color: "green"
    },
    {
      icon: HeadphonesIcon,
      title: "Crisis Support",
      details: ["24/7 Emergency Line", "(555) 911-HELP", "Immediate response guaranteed"],
      color: "red"
    }
  ];
// navigate('/booking/telehealth'
  const handleSubmit = async(e) => {
    e.preventDefault();

    const payload = {
      fullName: formData.name,
      emailAddress: formData.email,
      phoneNumber: formData.phone,
      userType: formData.userType,
      subject: formData.subject,
      message: formData.message
    };
    console.log('Form submitted:', payload);
    try {
      const respo = await SendMessagetoAdmin(payload)
      // console.log(respo?.data,"respo====")
       setFormData({
      name: '',
      email: '',
      phone: '',
      userType: '',
      subject: '',
      message: ''
    });
      ShowToast(respo?.data?.message)
    } catch (error) {
      console.log(error)
    }
  };


  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/30 to-purple-500/30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center space-y-8">
            <Badge className="bg-white/20 backdrop-blur-sm text-white text-lg px-6 py-3 rounded-full border border-white/30">
              <MessageCircle className="w-5 h-5 mr-2" />
              Get In Touch
            </Badge>

            <h1 className="text-6xl text-white leading-tight">
              We're Here to
              <span className="block text-amber-300">Support You</span>
            </h1>

            <p className="text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Our compassionate team is available 24/7 to answer your questions, provide support,
              and help you begin your mental health journey.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Button
                size="lg"
                variant="secondary"
                className="bg-white text-blue-700 hover:bg-gray-100 px-10 py-6 text-xl h-auto rounded-xl"
              >
                <Phone className="mr-3 h-6 w-6" />
                Call (555) 123-4567
              </Button>

              <Button
                size="lg"
                variant="outline"
                className="bg-white text-blue-700 hover:bg-gray-100 px-10 py-6 text-xl h-auto rounded-xl"
              >
                <Calendar className="mr-3 h-6 w-6" />
                Schedule Consultation
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl text-gray-900 mb-4">Choose How to Connect</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Multiple ways to reach our team and get the support you need
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-8">
            {contactMethods.map((method, index) => (
              <Card key={index} className="border-0 shadow-xl rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-500 card-interactive">
                <CardContent className="p-0">

                  <div className={`bg-${method.gradient} p-8 text-white`}>
                    <div className="flex items-center space-x-6">
                      <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                        <method.icon className="h-10 w-10 text-white" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-2xl font-semibold mb-2">{method.title}</h3>
                        <p className="text-white/90 text-lg">{method.description}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-8 space-y-6">
                    <div className="text-center space-y-2">
                      <div className={`text-2xl font-bold text-${method.color}-600`}>{method.action}</div>
                      <p className="text-gray-600">{method.subtext}</p>
                    </div>
                    <Button
                      className={`w-full bg-${method.color}-600 hover:bg-${method.color}-700 text-white py-4 text-lg rounded-xl`}
                      size="lg"
                      onClick={() => {
    if (method.action === "Book Now") {
      navigate('/booking/telehealth');
    }
  }}
                    >
                      {method.title === "Call Us" && <Phone className="mr-2 h-5 w-5" />}
                      {method.title === "Live Chat" && <MessageCircle className="mr-2 h-5 w-5" />}
                      {method.title === "Email Support" && <Mail className="mr-2 h-5 w-5" />}
                      {method.title === "Schedule Consultation" && <Calendar className="mr-2 h-5 w-5" />}
                      {method.action}
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <div className="mb-8">
                <h2 className="text-4xl text-gray-900 mb-4">Send Us a Message</h2>
                <p className="text-xl text-gray-600">
                  Fill out the form below and we'll get back to you within 2 hours during business hours.
                </p>
              </div>

              <Card className="shadow-xl border-0 rounded-2xl">
                <CardContent className="p-8">
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-gray-700 mb-2">Full Name</label>
                        <Input
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Your full name"
                          className="h-12 rounded-xl border-2 border-gray-200 focus:border-blue-500"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-gray-700 mb-2">Email Address</label>
                        <Input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="your.email@example.com"
                          className="h-12 rounded-xl border-2 border-gray-200 focus:border-blue-500"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-gray-700 mb-2">Phone Number</label>
                        <Input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="(555) 123-4567"
                          className="h-12 rounded-xl border-2 border-gray-200 focus:border-blue-500"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-gray-700 mb-2">I am a...</label>
                        <select
                          name="userType"
                          value={formData.userType}
                          onChange={handleInputChange}
                          className="w-full h-12 rounded-xl border-2 border-gray-200 focus:border-blue-500 px-3 bg-white"
                          required
                        >
                          <option value="">Select type</option>
                          <option value="patient">Patient</option>
                          <option value="family">Family Member/Caregiver</option>
                          <option value="facility">Care Facility</option>
                          <option value="provider">Healthcare Provider</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-gray-700 mb-2">Subject</label>
                      <Input
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        placeholder="How can we help you?"
                        className="h-12 rounded-xl border-2 border-gray-200 focus:border-blue-500"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 mb-2">Message</label>
                      <Textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Please provide details about your inquiry..."
                        rows={6}
                        className="rounded-xl border-2 border-gray-200 focus:border-blue-500 resize-none"
                        required
                      />
                    </div>

                    <Button
                      type="submit"
                      size="lg"
                      className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 text-lg rounded-xl"
                    >
                      <Send className="mr-2 h-5 w-5" />
                      Send Message
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>
            <div className="space-y-8">
              <div>
                <h2 className="text-4xl text-gray-900 mb-4">Visit Our Office</h2>
                <p className="text-xl text-gray-600 mb-8">
                  Our welcoming office provides a safe, comfortable space for in-person consultations and support.
                </p>
              </div>

              <div className="space-y-6">
                {officeInfo.map((info, index) => (
                  <Card key={index} className="border-2 border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300 rounded-2xl">
                    <CardContent className="p-8">
                      <div className="flex items-start space-x-6">
                        <div className={`w-16 h-16 bg-${info.color}-100 rounded-2xl flex items-center justify-center flex-shrink-0`}>
                          <info.icon className={`h-8 w-8 text-${info.color}-600`} />
                        </div>
                        <div className="flex-1">
                          <h3 className="text-xl font-semibold text-gray-900 mb-3">{info.title}</h3>
                          <div className="space-y-1">
                            {info.details.map((detail, detailIndex) => (
                              <p key={detailIndex} className="text-gray-600">{detail}</p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
              <Card className="border-0 shadow-xl rounded-2xl overflow-hidden">
                <CardContent className="p-0">
                  <div className="h-64 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                    <div className="text-center space-y-3">
                      <MapPin className="h-12 w-12 text-blue-600 mx-auto" />
                      <div>
                        <p className="text-lg font-medium text-blue-800">Interactive Map</p>
                        <p className="text-blue-600">Get directions to our office</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>


      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-8">
            <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto">
              <HeadphonesIcon className="h-12 w-12 text-white" />
            </div>

            <div>
              <h2 className="text-4xl text-white mb-4">Mental Health Emergency?</h2>
              <p className="text-xl text-red-100 max-w-3xl mx-auto mb-8">
                If you're experiencing a mental health crisis, don't wait. Our emergency support team is available 24/7.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Button
                size="lg"
                variant="secondary"
                className="bg-white text-red-600 hover:bg-gray-100 px-10 py-6 text-xl h-auto rounded-xl"
              >
                <Phone className="mr-3 h-6 w-6" />
                Call Crisis Line: (555) 911-HELP
              </Button>

              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white text-red-600 hover:bg-white hover:text-red-600 px-10 py-6 text-xl h-auto rounded-xl "
              >
                <MessageCircle className="mr-3 h-6 w-6" />
                Emergency Chat
              </Button>
            </div>

            <p className="text-red-200 text-lg">
              For life-threatening emergencies, call 911 or go to your nearest emergency room.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};